"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAsyncSelection = exports.ALLOWED_ACTION = void 0;
const react_1 = __importDefault(require("react"));
const async_1 = __importDefault(require("react-select/async"));
const formik_1 = require("formik");
const lodash_1 = require("lodash");
exports.ALLOWED_ACTION = "select-option";
const handleAsyncSelection = (...args) => (val, { action }) => {
    if (action === exports.ALLOWED_ACTION)
        args.forEach((setValue) => setValue(val));
};
exports.handleAsyncSelection = handleAsyncSelection;
const AsyncSelect = ({ name, placeholder = "", cacheOptions = true, currentValue, ...props }) => {
    const [, , helpers] = (0, formik_1.useField)(name);
    return (react_1.default.createElement(async_1.default, { cacheOptions: cacheOptions, placeholder: placeholder, defaultValue: currentValue, onChange: (0, exports.handleAsyncSelection)(helpers.setValue), ...(0, lodash_1.omit)(props, [
            "cacheOptions",
            "defaultValue",
            "onChange",
            "placeholder",
            "value",
        ]) }));
};
exports.default = AsyncSelect;
